const capitalize = (text: string) => (text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : '');

export { capitalize };
